import { render, staticRenderFns } from "./IncomeSettingsEditModal.vue?vue&type=template&id=39634703&"
import script from "./IncomeSettingsEditModal.vue?vue&type=script&lang=js&"
export * from "./IncomeSettingsEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports